/**
 * User Menu Component
 * Displays user profile and sign out option
 */

import { useState } from 'react'
import { useAuth } from '@/contexts/AuthContext'

export const UserMenu = () => {
  const { user, signOut } = useAuth()
  const [showMenu, setShowMenu] = useState(false)

  if (!user) return null

  const handleSignOut = async () => {
    await signOut()
    setShowMenu(false)
  }

  return (
    <div className="relative">
      <button
        onClick={() => setShowMenu(!showMenu)}
        className="flex items-center gap-2 px-4 py-2 rounded-lg hover:bg-gray-100 transition-colors"
      >
        {user.photoURL ? (
          <img
            src={user.photoURL}
            alt={user.displayName || 'User'}
            className="w-8 h-8 rounded-full"
          />
        ) : (
          <div className="w-8 h-8 rounded-full bg-gradient-to-br from-blue-500 to-purple-500 flex items-center justify-center text-white font-semibold">
            {user.isAnonymous ? 'G' : (user.displayName?.[0] || user.email?.[0] || 'U')}
          </div>
        )}
        <span className="text-sm font-medium text-gray-700">
          {user.isAnonymous ? 'Guest' : user.displayName || user.email || 'User'}
        </span>
      </button>

      {showMenu && (
        <>
          <div
            className="fixed inset-0 z-10"
            onClick={() => setShowMenu(false)}
          />
          <div className="absolute right-0 mt-2 w-56 bg-white rounded-lg shadow-lg border border-gray-200 py-2 z-20">
            <div className="px-4 py-2 border-b border-gray-200">
              <p className="text-sm font-medium text-gray-900">
                {user.isAnonymous ? 'Guest Account' : user.displayName || 'User'}
              </p>
              <p className="text-xs text-gray-500">{user.email || 'Anonymous'}</p>
            </div>

            <button
              onClick={handleSignOut}
              className="w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-red-50 transition-colors"
            >
              Sign Out
            </button>
          </div>
        </>
      )}
    </div>
  )
}
